import React from 'react';
import ImageComponent from 'atoms/Image';
import GreenCheck from 'styles/staticAssets/images/GreenCheck.svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';

const { CART_EDIT_NOTIFICATION } = TRANSLATE_MAPPING_KEY;

const CartEditNotification = ({ contentData }) => {
  let editItemFlag = contentData?.some(food => food.custom && food.customizable);
  let customiseFlag = editItemFlag
    ? localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMISE_ITEM_CART)
    : localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMISE_ITEM_CART);
  return editItemFlag && customiseFlag ? (
    <div data-testid='cart-edit-notification' className='cartEditMessage-container' id='cartEditMessage-container-id'>
      <ImageComponent srcFile={GreenCheck} className='cartEditMessage-icon' />
      <span className='cartEditMessage'>{translateWithI18Next(CART_EDIT_NOTIFICATION)}</span>
    </div>
  ) : null;
};

export default CartEditNotification;
